import { render, staticRenderFns } from "./TextSeparator.vue?vue&type=template&id=7d2b3490&"
import script from "./TextSeparator.vue?vue&type=script&lang=js&"
export * from "./TextSeparator.vue?vue&type=script&lang=js&"
import style0 from "./TextSeparator.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports